import { combineReducers } from 'redux';
import {
  MAILCHIMP_NOT_SET,
  GET_MAILCHIMP_SETTINGS,
  GET_MAILCHIMP_SETTINGS_ERROR,
  SET_MAILCHIMP_STATE,
  SAVE_MAILCHIMP_SETTINGS,
} from '../constants';

const mailchimpStateReducer = (state = MAILCHIMP_NOT_SET, { type, payload }) => {
  switch (type) {
    case SET_MAILCHIMP_STATE:
      return payload;
    default:
      return state;
  }
};

const mailchimpSettingsInitialState = {
  loading: false,
  settings: {},
};

const mailchimpSettingsReducer = (state = mailchimpSettingsInitialState, { type, payload }) => {
  switch (type) {
    case GET_MAILCHIMP_SETTINGS:
      return {
        ...state,
        loading: true,
      };
    case SAVE_MAILCHIMP_SETTINGS:
      return {
        loading: false,
        settings: payload,
      };
    case GET_MAILCHIMP_SETTINGS_ERROR:
      return {
        ...mailchimpSettingsInitialState,
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  mailchimpConnectionState: mailchimpStateReducer,
  mailchimpSettings: mailchimpSettingsReducer,
});

export default reducer;
